require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./community-policing-in-portland.json") })
        }
      }, "path---community-policing-in-portland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---community-policing-in-portland!./.cache/json/community-policing-in-portland.json
// module id = 861
// module chunks = 231608221292675